import React from 'react';
import { styled } from 'styled-components';

import { ColoredCard } from '../ColoredCard';
import { Flex } from '../Flex';
import { Styled as StyledIcon } from '../Icon/styles';
import { Text } from '../Text';

const StyledColoredCard = styled(ColoredCard)`
  position: relative;
`;

const CloseIconContainer = styled.div`
  padding: ${({ theme }) => theme.designTokens.bannerCloseIconPaddingY}
    ${({ theme }) => theme.designTokens.bannerCloseIconPaddingX};
  font-size: ${({ theme }) => theme.designTokens.bannerCloseIconFontSize};
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  z-index: 2;
  & ${StyledIcon.Container} {
    color: ${({ theme }) => theme.designTokens.bannerCloseIconColor};
  }
`;

const FlexRow = styled(Flex.Row)`
  flex-wrap: nowrap;
`;

const HeadingText = styled(
  ({ closeable, theme, ...props }: { closeable: boolean; theme?: any } & React.ComponentProps<typeof Text>) => (
    <Text {...props} />
  ),
)<{ closeable: boolean }>`
  margin-bottom: 0 !important;
  padding-right: ${({ closeable, theme }) =>
    closeable && `calc(${theme.designTokens.bannerCloseIconFontSize} + ${theme.designTokens.bannerCloseIconPaddingX})`};
`;

const VariantIconContainer = styled.div`
  line-height: 1.5rem;
  font-size: 0;
  > i {
    font-size: 1rem;
  }
`;

const CustomIconContainer = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  font-size: 2rem;
  line-height: 1;
`;

const ActionContainer = styled.div<{ closeable: boolean }>`
  align-self: center;
  flex-shrink: 0;
  margin-left: auto;
  // Clears the whole close icon box, its padding on both sides included: it sits on top of the row.
  // Padding, not margin: Flex.Row resets the margin-right of its last child.
  padding-right: ${({ closeable, theme }) =>
    closeable
      ? `calc(${theme.designTokens.bannerCloseIconFontSize} + 2 * ${theme.designTokens.bannerCloseIconPaddingX})`
      : 0};
`;

export const Styled = {
  ActionContainer,
  CustomIconContainer,
  CloseIconContainer,
  ColoredCard: StyledColoredCard,
  VariantIconContainer,
  FlexRow,
  HeadingText,
};
